module.exports = __webpack_public_path__ + "img/jiantou.e3724850.png";